// /media — real route (design doc's G2). The original (app/media/page.tsx)
// is already a pure `'use client'` page with no server auth gate (design doc
// §1b lists `/media` among the pages with "no server auth gate today; the
// APIs 401"). The scaffold placed this under `_authed` already
// (routes/agents.tsx) — design doc §1b calls that "a strict improvement, not
// parity debt", so it's kept rather than moved to core.tsx. Design doc §3c
// calls out a dedicated "Media-library chunk" as a route-level split, hence
// the lazy import here (MediaPage is the largest of this group's pages).
// Registered into the route tree from routes/agents.tsx.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const MediaPage = lazy(() =>
  import('@/app/media/page').then((m) => ({ default: m.default })),
);

export const mediaRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/media',
  component: MediaPage,
});
